import * as React from 'react';
import { PulseLoader } from 'react-spinners';
import './modal2.css';

interface Props {
    show: boolean;
}
interface State {
    seniorityToggle: boolean;
    artOfWorkToggle: boolean;
    industryToggle: boolean;
    countryToggle: boolean;
    consultantGroupToggle: boolean;
    languageToggle: boolean;
    keywordToggle: boolean;
    jurisdictionToggle: boolean;
}
export class Modal2 extends React.Component<Props, State> {
    
    constructor(props: Props) {
        super(props);
        this.state = {
            seniorityToggle: false,
            artOfWorkToggle: false,
            industryToggle: false,
            countryToggle: false,
            consultantGroupToggle: false,
            languageToggle: false,
            keywordToggle: false,
            jurisdictionToggle: false
            };
        }

        async componentDidMount() {
            console.log(this.props.show);
        }
        componentDidUpdate() {
            console.log(this.props.show);
        }
    
        render() {
            const {show} = this.props;
            const showHideClassName = show ? 'modal display-block' : 'modal display-none';
            return (
                <div className={showHideClassName}>
                    <div className="loading-wrapper" style={{ position: 'fixed', top: '50%', bottom: '50%', paddingLeft: '50%'}}>
                        <div className="loading-content" style={{ textAlign: 'center', margin: '0 auto'}}>
                            <PulseLoader
                                color="#95D737"
                                cssOverride={{}}
                                loading={true}
                                margin={1}
                                size={20}
                                speedMultiplier={0.5}
                            />
                        </div>
                    </div>
                </div>
            );
        }
  }



// WEBPACK FOOTER //
// ./src/widgets/modal/modal2/Modal2.tsx